module.exports = __webpack_public_path__ + "static/media/shop_empty_new.5657cee8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/shop_empty_new.png
// module id = 292
// module chunks = 40